import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.up('mobile')]: {
      paddingBottom: 0,
    },
  },
  title: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(4),
      fontSize: 24,
    },
  },
  text: {
    lineHeight: '21px',
    color: '#263238',
    [theme.breakpoints.up('mobile')]: {
      fontSize: 16,
      color: theme.palette.colors.black,
      lineHeight: '24px',
    },
  },
  formGroup: {
    margin: [theme.spacing(2), 0, 5],
    [theme.breakpoints.up('mobile')]: {
      margin: [theme.spacing(4), 0, theme.spacing(1)],
    },
  },
  fieldGroup: {
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
    },
  },
  field: {
    width: '100%',
    marginBottom: theme.spacing(3),
    '& .MuiInputBase-root': {
      height: '40px',
    },
    '& fieldset': {
      borderColor: theme.palette.colors.border,
    },
    '& label': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      marginBottom: theme.spacing(1),
      color: '#90A4AE',
    },
    '& input': {
      height: '100%',
      padding: [0, 14],
    },
  },
  referralLink: {
    minWidth: '100%',
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      minWidth: 350,
    },
  },
  button: {
    height: 40,
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      width: 100,
      marginLeft: theme.spacing(1),
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentDashboard/components/MyCustomLinkForm/useStyles.js